module.exports = __webpack_public_path__ + "img/2024-07-01a_1.99cc6c01.jpg";